module.exports = __webpack_public_path__ + "img/it.85c125d.jpg";